const videos = [
  {
    number: 1,
    text: "Post Partum Pelvic Health",
  },
  {
    number: 2,
    text: "Urinary Incontinence",
  },
  {
    number: 3,
    text: "Pelvic floor strengthening",
  },
  {
    number: 4,
    text: "Relaxing pelvic floor muscles",
  },
  {
    number: 5,
    text: "Pelvic pain",
  },
  {
    number: 6,
    text: "C-Section Scar Pain",
  },
  {
    number: 7,
    text: "Pain with intercourse",
  },
  {
    number: 8,
    text: "Pelvic Organ Prolapse",
  },
  {
    number: 9,
    text: "Pubic symphysis pain (pregnancy)",
  },
  {
    number: 10,
    text: "Diastisis Rectis Abdominis",
  },
];

export default videos;
